export const EDIT_SUCCESS = 'OCPI Хаб обновлен';
export const EDIT_ERROR = 'Не удалось обновить OCPI Хаб';
